<a href="https://wa.me/qr/76PZUOLTPESDC1" target="_blank" title="Chat with us on WhatsApp">
  <img class="wp-ic" src="assets/images/icons/ic-wp.png" alt="WhatsApp-icon" />
</a>